import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.throttleTimeout = null; // Stores the timeout ID for the cooldown period
    // Read throttle delay from data attribute (e.g., data-form-throttle-delay-value), defaulting to 300ms
    this.throttleDelay = parseInt(this.data.get("throttleDelay")) || 300;
    this.isThrottled = false; // Flag to indicate if the submit action is currently throttled
  }

  submit() {
    if (!this.isThrottled) {
      this.element.requestSubmit(); // Submit the form
      this.isThrottled = true; // Activate throttle
      // Set a timeout to reset the throttle state after the delay
      this.throttleTimeout = setTimeout(() => {
        this.isThrottled = false;
      }, this.throttleDelay);
    }
    // If isThrottled is true, subsequent calls to submit() are ignored until the timeout clears.
  }

  disconnect() {
    // Clear the timeout when the controller is disconnected to prevent memory leaks
    // and ensure the callback doesn't run on a detached element.
    if (this.throttleTimeout) {
      clearTimeout(this.throttleTimeout);
    }
  }
}
